var _path, _path2, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternedLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 240,
    viewBox: "0 0 77 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4923 210.09L13.478 180.9L1.0997 180.908L30.114 210.09L0.861511 239.541L1.09226 239.774L13.0091 239.766L42.4923 210.09Z",
    fill: "url(#paint0_linear_160_261)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2724 209.02L35.02 238.471L35.2507 238.703L47.1676 238.696L76.6508 209.02L47.629 179.83L35.2581 179.838L64.2724 209.02Z",
    fill: "url(#paint1_linear_160_261)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4923 150.146L13.478 120.957L1.0997 120.965L30.114 150.146L0.861511 179.598L1.09226 179.83L13.0091 179.823L42.4923 150.146Z",
    fill: "url(#paint2_linear_160_261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2724 149.076L35.02 178.528L35.2507 178.76L47.1676 178.752L76.6508 149.076L47.629 119.887L35.2581 119.894L64.2724 149.076Z",
    fill: "url(#paint3_linear_160_261)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4923 90.2012L13.478 61.0117L1.0997 61.0192L30.114 90.2012L0.861511 119.653L1.09226 119.885L13.0091 119.877L42.4923 90.2012Z",
    fill: "url(#paint4_linear_160_261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2724 89.1308L35.02 118.582L35.2507 118.815L47.1676 118.807L76.6508 89.1308L47.629 59.9414L35.2581 59.9489L64.2724 89.1308Z",
    fill: "url(#paint5_linear_160_261)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4923 30.2597L13.478 1.07031L1.0997 1.0778L30.114 30.2597L0.861511 59.7113L1.09226 59.9436L13.0091 59.9361L42.4923 30.2597Z",
    fill: "url(#paint6_linear_160_261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2724 29.1894L35.02 58.641L35.2507 58.8732L47.1676 58.8657L76.6508 29.1894L47.629 0L35.2581 0.00749183L64.2724 29.1894Z",
    fill: "url(#paint7_linear_160_261)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_261",
    x1: 22.3952,
    y1: 190.892,
    x2: 16.9318,
    y2: 232.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_160_261",
    x1: 53.6061,
    y1: 206.795,
    x2: 59.1373,
    y2: 248.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_160_261",
    x1: 22.3952,
    y1: 130.949,
    x2: 16.9318,
    y2: 172.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_160_261",
    x1: 53.6061,
    y1: 146.852,
    x2: 59.1373,
    y2: 188.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_160_261",
    x1: 22.3952,
    y1: 71.0037,
    x2: 16.9318,
    y2: 112.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_160_261",
    x1: 53.6061,
    y1: 86.9062,
    x2: 59.1373,
    y2: 128.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_160_261",
    x1: 22.3952,
    y1: 11.0623,
    x2: 16.9318,
    y2: 52.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_160_261",
    x1: 53.6061,
    y1: 26.9648,
    x2: 59.1373,
    y2: 68.4817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternedLines);
export default __webpack_public_path__ + "static/media/patternedLines.7444a1d1a89a5df2f0061edacaf6295a.svg";
export { ForwardRef as ReactComponent };